export default "__VITE_ASSET__D4iGFWsa__"